import { withTryCatchOpResult } from '@hc-frontend/core-utils-business-operation';
import type { ResponseSnowPlow } from '@hc-frontend/third-party-snowplow';
import { initSnowplowTracker } from '@hc-frontend/third-party-snowplow';
import Cookies from 'js-cookie';

import type { CompleteTrackingRepository } from '../../domain';
import type { CreateCompleteTrackingForSnowplowFactoryParams } from './create-complete-tracking-for-snowplow-factory.types';

// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace globalThis {
  // eslint-disable-next-line vars-on-top, no-var
  var snowplowTrackerInstance: ResponseSnowPlow['tracker'] | null;
}

export function createCompleteTrackingForSnowplowFactory({
  ...props
}: CreateCompleteTrackingForSnowplowFactoryParams):
  | CompleteTrackingRepository
  | undefined {
  const { pageView, tracker } = initSnowplowTracker({
    ...props,
  });

  const actualTracker = tracker || globalThis.snowplowTrackerInstance;

  if (!actualTracker) {
    return undefined;
  }
  if (tracker) globalThis.snowplowTrackerInstance = tracker;

  const userId = actualTracker.getUserId();
  const sessionId = actualTracker.getDomainUserInfo()[6];

  const setCustomUrl = () => {
    const overrideURLCookie = Cookies.get('x-search-params');

    actualTracker.setCustomUrl(window.location.href);

    if (overrideURLCookie) {
      actualTracker.setCustomUrl(
        `${window.location.href}?${overrideURLCookie}`,
      );
      Cookies.remove('x-search-params');
    }
  };

  return {
    setCustomUrl,
    pageView: withTryCatchOpResult(async (...args) => {
      pageView(...args);
    }, 'pageView'),
    tracking: {
      sessionId,
      userId,
    },
    tracker: actualTracker,
  };
}
